var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Grid } from "react-bootstrap";
import Button from "@irati/ui/src/Button";
import { IconTypes } from "@irati/ui/src/Icon";
import Link from "@irati/ui/src/Link";
import { Body } from "@irati/ui/src/Typography";
import IconText from "@irati/ui/src/IconText";
import Flex from "@irati/ui/src/Flex";
import { FormattedMessage, injectIntl, LangLoader } from "@irati/utils/lang";
import { PLATFORM } from "@irati-web/app/src/routeConfig";
import { CookieNotificationWrapper, FlexRow } from "./styled";
var COOKIE_NOTIFICATION_HIDE = "cookieNotificationHide";
var CookieNotification = /** @class */ (function (_super) {
    __extends(CookieNotification, _super);
    function CookieNotification() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showCookieNotification: true
        };
        _this.onHideCookieNotification = function () {
            _this.setState({ showCookieNotification: false });
            localStorage.setItem(COOKIE_NOTIFICATION_HIDE, "true");
        };
        return _this;
    }
    CookieNotification.prototype.render = function () {
        var formatMessage = this.props.formatMessage;
        if (!this.state.showCookieNotification || localStorage.getItem(COOKIE_NOTIFICATION_HIDE)) {
            return null;
        }
        var link = (React.createElement(Link, { href: formatMessage({ id: "platform.cookieNotification.link.href" }), target: "_blank" },
            React.createElement(FormattedMessage, { id: "platform.cookieNotification.link.text" })));
        return (React.createElement(LangLoader, { bucket: PLATFORM },
            React.createElement(CookieNotificationWrapper, null,
                React.createElement(Grid, null,
                    React.createElement(FlexRow, null,
                        React.createElement(IconText, { icon: IconTypes.info },
                            React.createElement(Body, { small: true, color: "white", marginBottom: 0 },
                                React.createElement(FormattedMessage, { id: "platform.cookieNotification.body", values: { link: link } }))),
                        React.createElement(Flex, { justifyContent: "center" },
                            React.createElement(Button, { inverted: true, onClick: this.onHideCookieNotification },
                                React.createElement(FormattedMessage, { id: "platform.cookieNotification.dismiss" }))))))));
    };
    return CookieNotification;
}(Component));
export default injectIntl(CookieNotification);
